import {call, put, takeEvery} from "redux-saga/effects";
import Api from "../services/Api";

function* fetchDealerSafes(action) {
  try {
    const safes = yield call(function() {
      return Api.get('/dealer/safes', action.parameters);
    });
    yield put({type: 'FETCH_DEALER_SAFES.SUCCESS', safes})
  } catch (error) {
    yield put({type: 'FETCH_DEALER_SAFES.FAILURE', error})
  }
}

export function* watchFetchDealerSafes() {
  yield takeEvery('FETCH_DEALER_SAFES.REQUEST', fetchDealerSafes)
}

function* saveDealerSafe(action) {
  try {
    const safe = yield call(function() {
      return Api.post('/dealer/safes', action.body);
    });
    yield put({type: 'SHOW_NOTIFICATION', notification: {message:'save.success'}});
    yield put({type: 'SAVE_DEALER_SAFE.SUCCESS', safe});
    yield put({type: 'FETCH_DEALER_SAFES.REQUEST', page: 0, size: 10});
    yield put({type: 'HIDE_SAFE_MODAL'});
  } catch (error) {
    yield put({type: 'SAVE_DEALER_SAFE.FAILURE', error})
  }
}

export function* watchSaveDealerSave() {
  yield takeEvery('SAVE_DEALER_SAFE.REQUEST', saveDealerSafe)
}

function* updateDealerSafe(action) {
  try {
    const safe = yield call(function() {
      return Api.put(`/dealer/safes/${action.id}`, action.body);
    });
    yield put({type: 'SHOW_NOTIFICATION', notification: {message:'save.success'}});
    yield put({type: 'UPDATE_DEALER_SAFE.SUCCESS', safe});
    yield put({type: 'FETCH_DEALER_SAFES.REQUEST', page: 0, size: 10});
    yield put({type: 'HIDE_SAFE_MODAL'});
  } catch (error) {
    yield put({type: 'UPDATE_DEALER_SAFE.FAILURE', error})
  }
}

export function* watchUpdateDealerSave() {
  yield takeEvery('UPDATE_DEALER_SAFE.REQUEST', updateDealerSafe)
}

function* deleteDealerSafe(action) {
  try {
    const safe = yield call(function() {
      return Api.delete(`/dealer/safes/${action.safeNumber}`);
    });
    yield put({type: 'SHOW_NOTIFICATION', notification: {message:'save.success'}});
    yield put({type: 'DELETE_DEALER_SAFE.SUCCESS', safe});
    yield put({type: 'FETCH_DEALER_SAFES.REQUEST', page: 0, size: 10});
    yield put({type: 'HIDE_SAFE_MODAL'});
  } catch (error) {
    yield put({type: 'DELETE_DEALER_SAFE.FAILURE', error})
  }
}

export function* watchDeleteDealerSafe() {
  yield takeEvery('DELETE_DEALER_SAFE.REQUEST', deleteDealerSafe)
}



// WEBPACK FOOTER //
// ./src/sagas/dealerSafes.js